// extracted by css-extract-rspack-plugin
export default {"searchForm":"searchForm-Qe5m63","entityIdsInput":"entityIdsInput-X5K0AQ","card":"card-Erh0re","cardBody":"cardBody-Tr65W7"};